<div class="sm:mx-auto sm:w-full sm:max-w-sm">
  <div class=" flex flex-row items-center justify-center">
  <h2 class="mt-4 text-center text-2xl font-normal leading-9 tracking-tight text-gray-900">Redirecionando...</h2>
  </div>
</div>

